import { render, staticRenderFns } from "./inviteInfo.vue?vue&type=template&id=8bdb4f50&scoped=true"
import script from "./inviteInfo.vue?vue&type=script&lang=js"
export * from "./inviteInfo.vue?vue&type=script&lang=js"
import style0 from "./inviteInfo.vue?vue&type=style&index=0&id=8bdb4f50&prod&lang=less"
import style1 from "./inviteInfo.vue?vue&type=style&index=1&id=8bdb4f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdb4f50",
  null
  
)

export default component.exports